// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.affiliate-sidebar-wrapper {
    position: fixed;
    left: 0;
    top: 0;
    height: 100%;
    width: 240px;
    background: #11101d;
    padding: 6px 14px;
    z-index: 99;
    transition: all 0.5s ease;
}
  
.affiliate-logo-container {
    height: 60px;
    display: flex;
    align-items: center;
    position: relative;
}
  
.affiliate-logo-icon {
    height: 35px;
    margin-right: 10px;
}
  
.affiliate-logo-text {
    color: #fff;
    font-size: 20px;
    font-weight: 600;
}
  
.affiliate-nav-list {
    margin-top: 20px;
    padding: 0;
}
  
.affiliate-nav-item {
    position: relative;
    margin: 8px 0;
    list-style: none;
}
  
.affiliate-nav-link {
    display: flex;
    height: 50px;
    align-items: center;
    text-decoration: none;
    border-radius: 12px;
    transition: all 0.4s ease;
    background: #11101d;
}
  
.affiliate-nav-link:hover {
    background: #fff;
    color: #11101d;
}
  
.affiliate-nav-link.active {
    background: #fff;
    color: #11101d;
}
  
.affiliate-nav-icon {
    min-width: 50px;
    text-align: center;
    height: 50px;
    line-height: 50px;
    color: #fff;
    font-size: 20px;
}
  
.affiliate-nav-link:hover .affiliate-nav-icon,
.affiliate-nav-link.active .affiliate-nav-icon {
    color: #11101d;
}
  
.affiliate-link-text {
    color: #fff;
    font-size: 15px;
    font-weight: 400;
    white-space: nowrap;
}
  
.affiliate-nav-link:hover .affiliate-link-text,
.affiliate-nav-link.active .affiliate-link-text {
    color: #11101d;
}
`, "",{"version":3,"sources":["webpack://./src/affilate-app/pages/_layout/elements/sidebar.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,OAAO;IACP,MAAM;IACN,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,qBAAqB;IACrB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,WAAW;IACX,eAAe;AACnB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;;IAEI,cAAc;AAClB","sourcesContent":[".affiliate-sidebar-wrapper {\r\n    position: fixed;\r\n    left: 0;\r\n    top: 0;\r\n    height: 100%;\r\n    width: 240px;\r\n    background: #11101d;\r\n    padding: 6px 14px;\r\n    z-index: 99;\r\n    transition: all 0.5s ease;\r\n}\r\n  \r\n.affiliate-logo-container {\r\n    height: 60px;\r\n    display: flex;\r\n    align-items: center;\r\n    position: relative;\r\n}\r\n  \r\n.affiliate-logo-icon {\r\n    height: 35px;\r\n    margin-right: 10px;\r\n}\r\n  \r\n.affiliate-logo-text {\r\n    color: #fff;\r\n    font-size: 20px;\r\n    font-weight: 600;\r\n}\r\n  \r\n.affiliate-nav-list {\r\n    margin-top: 20px;\r\n    padding: 0;\r\n}\r\n  \r\n.affiliate-nav-item {\r\n    position: relative;\r\n    margin: 8px 0;\r\n    list-style: none;\r\n}\r\n  \r\n.affiliate-nav-link {\r\n    display: flex;\r\n    height: 50px;\r\n    align-items: center;\r\n    text-decoration: none;\r\n    border-radius: 12px;\r\n    transition: all 0.4s ease;\r\n    background: #11101d;\r\n}\r\n  \r\n.affiliate-nav-link:hover {\r\n    background: #fff;\r\n    color: #11101d;\r\n}\r\n  \r\n.affiliate-nav-link.active {\r\n    background: #fff;\r\n    color: #11101d;\r\n}\r\n  \r\n.affiliate-nav-icon {\r\n    min-width: 50px;\r\n    text-align: center;\r\n    height: 50px;\r\n    line-height: 50px;\r\n    color: #fff;\r\n    font-size: 20px;\r\n}\r\n  \r\n.affiliate-nav-link:hover .affiliate-nav-icon,\r\n.affiliate-nav-link.active .affiliate-nav-icon {\r\n    color: #11101d;\r\n}\r\n  \r\n.affiliate-link-text {\r\n    color: #fff;\r\n    font-size: 15px;\r\n    font-weight: 400;\r\n    white-space: nowrap;\r\n}\r\n  \r\n.affiliate-nav-link:hover .affiliate-link-text,\r\n.affiliate-nav-link.active .affiliate-link-text {\r\n    color: #11101d;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
